export default __webpack_public_path__ + "static/media/char_body_007.e28b568d.png";